import { Heading, Typography } from '@altify/components';
import { useNavigate } from '@tanstack/react-router';
import CurrencyIcon from 'app/_authenticated/trade/components/CurrencyIcon/CurrencyIcon';
import imgChevron from 'app/_authenticated/trade/recurring-buy/assets/chevron-right.svg';

export function RecurringBuyCard({
  productCode,
  productName,
  interval,
  amount,
  paused = false,
  onShowRecurringBuyDetails,
}: {
  productCode: string;
  productName: string;
  interval: string;
  amount: string;
  paused: boolean;
  onShowRecurringBuyDetails?: () => void;
}) {
  const navigate = useNavigate();
  return (
    <>
      <div
        className="bg-[#1E2741] rounded-md shrink-0 hover:cursor-pointer mb-2"
        onClick={() => onShowRecurringBuyDetails?.()}>
        <div className="flex flex-row items-center py-3 px-4 justify-between w-full">
          <div className="flex flex-row items-center basis-2/3 gap-2">
            <div className="w-[40px]">
              <CurrencyIcon
                code={productCode}
                isLockedAsset={paused}
                size={40}
              />
            </div>
            <div className="ml-4 flex flex-col flex-shrink">
              <Typography>{productName}</Typography>
              <Typography className="text-gray-100" size="small">
                {interval}
              </Typography>
            </div>
          </div>
          <div className="flex flex-row items-center w-[16rem] justify-end">
            {amount && <Heading level={5}>{amount}</Heading>}
            <img
              className="ml-6 rounded-xl h-8 w-8"
              src={imgChevron}
            />
          </div>
        </div>
      </div>
    </>
  );
}
